import {Entry} from '@web/core/constants'
import makeSlice from '@web/slices/agreement/sliceMaker'

import {initPaymentMethodManagement} from '../../actions'

const slice = makeSlice({
    extraReducers(builder) {
        builder.addCase(initPaymentMethodManagement.fulfilled, (state, {payload: {entry}}) => {
            const selected = {
                /** Service가 booking이면 booking 동의를 받아야 해서 false로 init한다 */
                booking: entry !== Entry.BOOKING,
                customOrder: true,
                familyPay: true,
                mallContract: true,
                personalDataCrossBorderTransfer: true,
                preOrder: true,
                thirdPeople: true,
                shoppingSubscription: true,
            }

            /** 모두 true라면 agree를 받을 필요가 없어 true로 init한다. */
            state.enabled = Object.values(selected).every((agreeNotNeeded) => agreeNotNeeded)
            state.selected = selected
        })
    },
})

export default slice.reducer
